import Vue from 'vue'
import vSelect from 'vue-select'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: h => h('feather-icon', { props: { size: '14', icon: 'XIcon' } }),
  },
  OpenIndicator: {
    render() {
      return (
        <GjIcon
          class="icon-wrapper-v-select"
          name="ArrowDown_fill"
          size="21"
        />
      )
    },
  },
})

Vue.component(vSelect)
